/* 🤖 this file was generated by svg-to-ts */
export const matIconNavigateNext: {
  name: 'navigate-next';
  data: string;
} = {
  name: 'navigate-next',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.02 6 8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"/></svg>`
};
